<template>
  <div>
    <p class="text-h6 text-md-h4 text-center pa-4">Преподаватели</p>

    <v-sheet class="d-flex justify-center align-center flex-wrap mentors">
      <div
        class="text-center mentor-card"
        v-for="(course, index) in courses"
        :key="index"
      >
        <v-avatar color="grey" size="200" tile class="rounded-circle">
          <v-img :src="getImgUrl(course.avatar)"></v-img>
        </v-avatar>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              {{ course.teacher }}
            </v-list-item-title >
            <v-list-item-subtitle>{{ course.name }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ course.age }}</v-list-item-subtitle>
            <v-list-item-subtitle v-html="course.skills" class="hyphenation" ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import courses from "../courses/courses";
import { gsap } from "gsap";

export default {
  data: () => ({
    courses: courses,
  }),
  methods: {
    getImgUrl(pic) {
      return require("../assets/images/" + pic);
    },
  },
  mounted() {
    gsap.from(".mentors", {
      scrollTrigger: {
        trigger: ".mentors",
        start: "top bottom-=200px",
        once: true,
        toggleActions: "restart pause resume pause",
      },
      y: 30,
      duration: 2,
    });
  },
};
</script>
<style lang="scss" scoped>
.mentor-card {
  max-width: 250px;
}
.hyphenation{
 word-break: keep-all;
}
</style>